module.exports = __webpack_public_path__ + "img/safetyShieldGreen.baaeb91b.png";